<template>
	<div>
		<el-button-group>
			<el-button :type="type==1?'primary':'default'" size="mini" icon="el-icon-select" @click="changeType(1)">新闻评论</el-button>
			<el-button :type="type==2?'primary':'default'" size="mini" icon="el-icon-select" @click="changeType(2)">信息评论</el-button>
		</el-button-group>
		<el-button-group>
			<el-button type="primary" size="mini" icon="el-icon-select" @click="selectAll">全选</el-button>
			<el-button type="warning" size="mini" icon="el-icon-select" @click="selectDiff">反选</el-button>
		</el-button-group>
		<el-dropdown trigger="click">
			<el-button type="primary" icon="el-icon-setting" size="mini">
				筛选
				<i class="el-icon-arrow-down el-icon--right"></i>
			</el-button>
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item v-for="(items, index) in filtrateList" :key="index">
					<el-dropdown trigger="hover" placement="right-start" @command="seleCommand">
						<el-button type="text" icon="el-icon-caret-right" size="mini">{{ items.label }}</el-button>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item
								icon="el-icon-caret-right"
								v-for="(item, key) in items.seconds"
								:key="key"
								:command="{ indexa: index, indexb: key, param: items.paramValue, paramval: item.val }"
								:class="item.checked ? 'color-blue' : ''"
							>
								{{ item.label }}
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>
		<el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteMessage">删除</el-button>
		<el-button type="warning" size="mini" icon="el-icon-refresh" @click="getList()">刷新</el-button>
		<el-dropdown trigger="click">
			<el-button type="success" icon="el-icon-setting" size="mini">
				设置
				<i class="el-icon-arrow-down el-icon--right"></i>
			</el-button>
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item v-for="(items, index) in setList" :key="index">
					<el-dropdown trigger="hover" placement="right-start" @command="setCommand">
						<el-button type="text" icon="el-icon-caret-right" size="mini">{{ items.label }}</el-button>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item
								icon="el-icon-caret-right"
								v-for="(item, index) in items.seconds"
								:key="index"
								:command="{ setParam: items.paramValue, setParamVal: item.val }"
							>
								{{ item.label }}
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>
		<el-table
			:data="messageList"
			style="width: 100%;margin-bottom: 20px;"
			row-key="dcid"
			:stripe="true"
			:default-sort="{ prop: 'dcid', order: 'descending' }"
			@sort-change="sortChange"
			@selection-change="selectChange"
			tooltip-effect="dark"
			ref="multipleTable"
			border
		>
			<el-table-column type="selection" width="55"></el-table-column>
			<el-table-column prop="dcid" label="信息ID" width="100" sortable=""></el-table-column>
			<el-table-column prop="ip" label="用户ip" ></el-table-column>
			<el-table-column prop="username" label="用户昵称"></el-table-column>
			<el-table-column prop="title" label="关联文章" :show-overflow-tooltip='true'>
				<template slot-scope="scope">
					<a :href="scope.row.link">{{scope.row.title}}</a>
				</template>
			</el-table-column>
			<el-table-column prop="content" label="评论内容" ></el-table-column>
			<el-table-column prop="addtime" label="发布时间" sortable></el-table-column>
			<el-table-column prop="status" label="回复状态" sortable>
				<template slot-scope="scope">
					<span v-if="scope.row.status == 0" class="color-red">待审核</span>
					<span v-if="scope.row.status == 1" class="color-green">审核通过</span>
					<span v-if="scope.row.status == 2" class="color-gray">审核拒绝</span>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="150">
				<template slot-scope="scope">
					<el-button type="primary" size="small" @click="setCommentParam(scope.row.dcid,'status',1)">通过</el-button>
					<el-button type="danger" size="small" @click="setCommentParam(scope.row.dcid,'status',2)">拒绝</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="block">
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="thispage"
				:page-sizes="pageSizes"
				:page-size="pagesize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
			></el-pagination>
		</div>
		<!-- 添加留言板 -->
		<el-dialog title="回复留言" class="text-left" :visible.sync="dialogVisible" width="80%" style="z-index: 2;" :close-on-click-modal="false">
			<el-divider>留言属性</el-divider>
			<div>
				<el-row :gutter="20">
					<el-col :md="4" :sm="6" :lg="3">发布时间</el-col>
					<el-col :span="18">{{ currentScope.addtime }}</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :md="4" :sm="6" :lg="3">操作IP</el-col>
					<el-col :span="18">{{ currentScope.ip }}</el-col>
				</el-row>
			</div>
			<el-divider>留言内容</el-divider>
			<div>
				<!-- <el-row :gutter="20" v-for="(attr, index) in attrList" :key="index">
					<el-col :md="4" :sm="6" :lg="3">{{ attr.typename }}</el-col>
					<el-col :span="18">{{ currentScope[attr.attrname] }}</el-col>
				</el-row> -->
			</div>
			<el-divider>留言回复</el-divider>
			<template v-if="!currentScope.status">
				<el-row :gutter="20">
					<el-col :md="4" :sm="6" :lg="3">回复邮箱</el-col>
					<el-col :span="18">
						<el-input type="text" v-model="writeBack.mail" placeholder="请输入回复邮箱"></el-input>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :md="4" :sm="6" :lg="3">回复标题</el-col>
					<el-col :span="18">
						<el-input type="text" v-model="writeBack.title" placeholder="请输入回复标题,选填"></el-input>
					</el-col>
				</el-row>
				<vue-ueditor-wrap class="editor" @ready="ready" :destroy="true" v-model="writeBack.info" :config="myConfig"></vue-ueditor-wrap>
			</template>
			<div v-else>
				<el-row :gutter="20">
					<el-col :md="4" :sm="6" :lg="3">回复标题</el-col>
					<el-col :span="18">{{ currentScope.backtitle }}</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :md="4" :sm="6" :lg="3">回复时间</el-col>
					<el-col :span="18">{{ currentScope.backtime }}</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :md="4" :sm="6" :lg="3">发信邮箱</el-col>
					<el-col :span="18">{{ currentScope.send_mail }}</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :md="4" :sm="6" :lg="3">接收邮箱</el-col>
					<el-col :span="18">{{ currentScope.to_mail }}</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :md="4" :sm="6" :lg="3">回复内容</el-col>
					<el-col :span="18"><div v-html="currentScope.backcontent"></div></el-col>
				</el-row>
			</div>
			<div slot="footer" class="dialog-footer text-center">
				<el-button type="warning" @click="dialogVisible = false">关闭窗口</el-button>
				<el-button v-if="!currentScope.status" type="primary" @click="writeConfirm">确认回复</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { mapActions } from 'vuex';
import VueUeditorWrap from 'vue-ueditor-wrap'; // ES6 Module
export default {
	name: '',
	components: {
		VueUeditorWrap
	},
	data() {
		return {
			type:1,
			messageList: [],
			thispage: 1,
			total: 0,
			pagesize: 10, //每页显示条数
			pageSizes: [10, 20, 30], //每页显示个数选择器
			sort_param: 'dcid', //排序字段
			sort_type: 'desc', //排序方式ascending = asc;descending = desc,'' = asc;
			filtrateList: [
				{
					label: '审核状态',
					paramValue: 'status',
					seconds: [
						{
							val: '',
							label: '全部',
							checked: true
						},
						{
							val: 1,
							label: '已审核'
						},
						{
							val: 0,
							label: '未审核'
						}
					]
				}
			],
			setList: [
				{
					label: '审核状态',
					paramValue: 'status',
					seconds: [
						{
							val: 1,
							label: '通过'
						},
						{
							val: 2,
							label: '拒绝'
						}
					]
				}
			],
			setParam: '',
			setParamVal: '',
			selectParams: [],
			selectedMessageIds: [],
			myConfig: {
				// 编辑器不自动被内容撑高
				autoHeightEnabled: false,
				// 初始容器高度
				initialFrameHeight: 500,
				// 初始容器宽度
				initialFrameWidth: '98%',
				// 上传文件接口
				serverUrl: this.HOST + this.ueditorPath + '/UEditor/php/controller.php',
				// UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况
				UEDITOR_HOME_URL: this.ueditorPath + '/UEditor/'
			},
			dialogVisible: false,
			currentScope: '', //选中要回复的信息
			writeBack: {
				title:'',
				mail: '',
				info: ''
			} //回复
		};
	},
	mounted() {
		// this.getBBSModuleList();
		this.getList(true);
	},
	methods: {
		...mapActions({
			exit: 'auth/logout'
		}),
		changeType(type){
			this.type = type;
			this.getList();
		},
		getList(firstLoad = false) {
			let separ = [];
			for (let i in this.selectParams) {
				console.log(i, this.selectParams[i]);
				separ.push({ param: i, paramVal: this.selectParams[i] });
			}
			this.$axios({
				url: this.HOST + '/admin.module/commentList',
				method: 'post',
				data: {
					thispage: this.thispage,
					pagesize: this.pagesize,
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					sort_param: this.sort_param,
					sort_type: this.sort_type,
					selectParams: separ,
					firstLoad: firstLoad,
					type:this.type//1文章评论2信息发布评论
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.messageList = res.data.data;
						this.total = res.data.total;
					}
				})
				.catch(error => {
					console.log(error);
				});
		},
		sortChange({ column, prop, order }) {
			console.log(column, prop, order);
			this.sort_param = prop;
			this.sort_type = order == 'descending' ? 'desc' : 'asc';
			this.getBBSModuleList();
		},
		handleSizeChange(val) {
			// console.log(`每页 ${val} 条`);
			this.pagesize = val;
			this.getBBSModuleList();
		},
		handleCurrentChange(val) {
			// console.log(`当前页: ${val}`);
			this.thispage = val;
			this.getBBSModuleList();
		},
		addFunction(scope = false) {
			if (!scope) {
				this.addModuleInfo = {
					id: '',
					name: '',
					param_list: []
				};
			} else {
				this.addModuleInfo = JSON.parse(JSON.stringify(scope));
			}
			console.log(this.addModuleInfo);
			this.addDialogShow = true;
		},
		selectChange(selection) {
			console.log(selection);
			let arr = [];
			for (let i in selection) {
				arr.push(selection[i].dcid);
			}
			this.selectedMessageIds = arr;
			console.log(this.selectedMessageIds);
		},
		// 全选
		selectAll() {
			this.messageList.map(item => {
				this.$refs.multipleTable.toggleRowSelection(item, true); //切换该子节点选中状态
			});
		},
		// 反选
		selectDiff() {
			let diff = [];
			this.messageList.map(item => {
				if (this.selectedMessageIds.indexOf(item.dcid) != -1) {
					this.$refs.multipleTable.toggleRowSelection(item, false); //切换该子节点选中状态
				} else {
					diff.push(item.dcid);
					this.$refs.multipleTable.toggleRowSelection(item, true); //切换该子节点选中状态
				}
			});
			this.selectedMessageIds = diff;
			console.log(this.selectedMessageIds);
		},
		deleteMessage() {
			if (!this.selectedMessageIds.length) {
				this.$message.error('尚未选中任何信息！');
				return false;
			}
			this.$confirm('是否要删除所选信息？一经删除不可恢复！')
				.then(() => {
					this.$axios({
						url: this.HOST + '/admin.module/deleteBBSMessage',
						method: 'post',
						data: {
							adminid: JSON.parse(this.$store.state.user.userInfo).id,
							token: JSON.parse(this.$store.state.user.userInfo).token,
							mids: this.selectedMessageIds
						}
					})
						.then(res => {
							console.log(res.data);
							if (res.data.status == 0) {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'admininfo_error') {
									this.exit().then(res => {
										console.log(res);
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							} else {
								this.$message.success(res.data.msg);
								this.getList();
							}
						})
						.catch(err => {});
				})
				.catch(() => {});
		},
		seleCommand(command) {
			console.log('sele:', command);
			this.selectParams[command.param] = command.paramval;
			this.filtrateList[command.indexa].seconds.map(item => {
				this.$set(item, 'checked', false);
			});
			this.filtrateList[command.indexa].seconds[command.indexb].checked = true;
			console.log(this.selectParams);
			this.getList();
		},
		setCommand(command) {
			console.log('set:', command);
			this.setParam = command.setParam;
			this.setParamVal = command.setParamVal;
			this.setCommentParam();
		},
		setCommentParam(id="",setParam="",setParamVal="") {
			if (!id&&!this.selectedMessageIds.length) {
				this.$message.error('尚未选中任何内容');
				return false;
			}
			this.$axios({
				url: this.HOST + '/admin.module/setCommentParam',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					ids: id?String(id).split(','):this.selectedMessageIds,
					setParam: setParam?setParam:this.setParam,
					setParamVal: setParamVal?setParamVal:this.setParamVal
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						if(id){
							this.messageList.map(item => {
								if (item.dcid == id) {
									item[setParam] = setParamVal;
								}
							})
						}else{
							this.messageList.map(item => {
								if (this.selectedMessageIds.indexOf(item.dcid) !== -1) {
									item[this.setParam] = this.setParamVal;
								}
							})
						}
						this.$message.success(res.data.msg);
						// this.selectedMessageIds = []//选中值初始化
					}
				})
				.catch(err => {});
		},
		ready() {},
		writeback(scope) {
			this.currentScope = scope;
			this.dialogVisible = true;
		},
		writeConfirm(){
			if(!this.writeBack.mail){
				this.$message.error('回复邮箱未填写');
				return false;
			}
			if(!this.writeBack.info){
				this.$message.error('回复内容为空');
				return false;
			}
			this.$confirm('确认信息无误并回复？')
			.then(success=>{
				this.$axios({
					url: this.HOST + '/admin.module/messageWriteBack',
					method: 'post',
					data: {
						adminid: JSON.parse(this.$store.state.user.userInfo).id,
						token: JSON.parse(this.$store.state.user.userInfo).token,
						backInfo: this.writeBack,
						dcid:this.currentScope.dcid
					}
				})
					.then(res => {
						console.log(res.data);
						if (res.data.status == 0) {
							this.$message.error(res.data.msg);
							if (res.data.admin_err == 'admininfo_error') {
								this.exit().then(res => {
									console.log(res);
									if (res.actionStatus == 1) {
										this.$router.push('/login');
									}
								});
							}
						} else {
							this.$message.success(res.data.msg);
							this.currentScope.status = 1;//修改信息状态
							this.dialogVisible = false;
							this.writeBack = {//初始化
								title:'',
								mail:'',
								info:''
							}
						}
					})
					.catch(err => {});
			})
			.catch(err=>{
				console.log('提交出错');
			})
		}
	}
};
</script>
<style>
.el-tree-node.is-expanded > .el-tree-node__children {
	display: flex;
	flex-flow: row wrap;
}
.el-tree::-webkit-scrollbar {
	display: none; /* Chrome Safari */
}
.el-button-group + .el-button-group{
	margin-left: 10px;
}
.el-tag + .el-tag {
	margin-left: 10px;
}
.button-new-tag {
	margin-left: 10px;
	height: 32px;
	line-height: 30px;
	padding-top: 0;
	padding-bottom: 0;
}
.input-new-tag {
	width: 90px;
	margin-left: 10px;
	vertical-align: bottom;
}
.el-table{
	margin-top: 10px;
}
</style>
